import { DEFAULT_PILLAR_ICON } from './pillarSurface';

import { getIconSvg } from '@/utils/iconSvgs';

interface PillarIconProps {
    icon?: string | null;
    size: number;
}

/**
 * The glyph drawn inside a pillar's icon tile, from the icon bank. The tile itself -- background,
 * radius, shadow -- stays owned by each call site; this only renders what goes inside it, so every
 * place a pillar icon is drawn falls back to the same default glyph.
 */
export default function PillarIcon({ icon, size }: PillarIconProps) {
    return getIconSvg(icon || DEFAULT_PILLAR_ICON, size);
}
